var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-card"},[_c('p',{staticClass:"body-2 m-0 text-center"},[_vm._v(" "+_vm._s(_vm.textDescription)+" "),_c(_vm.component.component,_vm._b({tag:"component",staticClass:"link-2"},'component',_vm.component.attrs,false),[_vm._v(_vm._s(_vm.redirectToDescription)+" >")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }